import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { Briefcase } from "lucide-react";
import { toast } from "sonner";

/**
 * 18-B2 item 7: admin — employer-team approval queue + volunteering-day
 * enquiries (concierge inbox).
 */
export function EmployerPanel() {
  const [pending, setPending] = useState([]);
  const [enquiries, setEnquiries] = useState([]);

  const load = () => {
    api.pendingEmployerTeams().then(setPending).catch(() => {});
    api.adminEmployerEnquiries().then(setEnquiries).catch(() => {});
  };
  useEffect(load, []);

  const act = async (team, fn, msg) => {
    try {
      await fn(team.id);
      toast.success(`${team.name} ${msg}`);
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="bg-white border border-neutral-200 rounded-2xl p-6 mt-8" data-testid="admin-employer-panel">
      <h2 className="font-display text-2xl text-forest tracking-tight inline-flex items-center gap-2">
        <Briefcase className="w-5 h-5 text-terracotta" /> Employer teams
      </h2>

      <div className="mt-4">
        <div className="text-xs uppercase tracking-[0.18em] text-forest/70 font-bold">Awaiting approval</div>
        {pending.length === 0 && <div className="text-sm text-neutral-400 py-3" data-testid="employer-queue-empty">Queue is clear.</div>}
        <div className="space-y-2 mt-2" data-testid="employer-teams-queue">
          {pending.map((t) => (
            <div key={t.id} className="border border-neutral-200 rounded-xl px-4 py-3 flex items-center gap-3 flex-wrap" data-testid={`employer-team-${t.id}`}>
              <div className="min-w-0 flex-1">
                <b className="text-forest text-sm">{t.name}</b>
                <div className="text-xs text-neutral-500">Requested by {t.owner_name}</div>
              </div>
              <Button data-testid={`employer-approve-${t.id}`} onClick={() => act(t, api.approveEmployerTeam, "approved")} className="rounded-full bg-forest hover:bg-forest-hover h-8 px-4 text-xs">Approve</Button>
              <Button data-testid={`employer-reject-${t.id}`} onClick={() => act(t, api.rejectEmployerTeam, "rejected")} variant="outline" className="rounded-full h-8 px-4 text-xs text-red-600 border-red-200 hover:bg-red-50">Reject</Button>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-6">
        <div className="text-xs uppercase tracking-[0.18em] text-forest/70 font-bold">Volunteering day enquiries</div>
        {enquiries.length === 0 && <div className="text-sm text-neutral-400 py-3">No enquiries yet.</div>}
        <div className="space-y-1.5 mt-2" data-testid="employer-enquiries-list">
          {enquiries.map((e) => (
            <div key={e.id} className="border-b border-neutral-100 py-2 text-sm flex items-center justify-between gap-3" data-testid={`enquiry-${e.id}`}>
              <div className="min-w-0">
                <b className="text-forest">{e.company}</b>
                <span className="text-neutral-500"> · {e.size} · {e.area}</span>
              </div>
              <div className="text-xs text-neutral-400 shrink-0">prefers {e.preferred_month}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
